import React from "react";
import { version } from "../../global";

export default function BottomLayer(props: {
  value?: string;
  suffix?: string | React.ReactNode;
  className?: string;
}) {
  const { value } = props;

  return (
    <div className={props.className}>
      {value ? (
        value
      ) : (
        <>
          {version} 京ICP备2024078129号-1 Copyright © 2024{" "}
          <a
            href="https://www.capitalren.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            北京京兆人智能技术有限公司
          </a>
          {props?.suffix ? ` - ${props?.suffix}` : ""}
        </>
      )}
    </div>
  );
}
